import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Main, Dashboard, InputColorPicker, Select } from "components";
import useCreate from "hooks/useCreate";

import { ReactComponent as PlatformIcon } from "icons/platform.svg";

import platform_type_options from "utils/select_options/platform_types";
import available_countries_options from "utils/select_options/available_countries";
import available_currencies_options from "utils/select_options/available_currencies";
import available_languages_options from "utils/select_options/available_languages";

const InputField = (props) => <Input {...props} />;
const InputColorPickerField = (props) => <InputColorPicker {...props} />;
const SelectField = (props) => <Select {...props} />;

const PlatformsNew = ({ handleSubmit, change, pristine, history }) => {
  const { is_creating, create } = useCreate({
    path: "/platforms",
    onSuccess: ({ id }) => history.push(`/platforms/${id}`),
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) => create(values);

  return (
    <Main
      page={{
        name: "Platformy",
        icon: <PlatformIcon />,
        breadcrumbs: [
          {
            name: "Platformy",
            path: "/platforms",
          },
          { name: "Dodaj platformę" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            footer={
              <>
                <Button
                  type="cancel"
                  onClick={() => history.push("/platforms")}
                />
                <Button
                  type="save"
                  text="Utwórz"
                  disabled={pristine || is_creating}
                  onClick={handleSubmit(onSubmit)}
                />
              </>
            }
          >
            <form
              className="dashboard__form"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <Field
                name="name"
                label="Nazwa"
                component={InputField}
                type="text"
              />
              <div className="row m-b-10">
                <div className="box-6">
                  <Field
                    name="label_text"
                    label="Skrócona nazwa"
                    component={InputField}
                    type="text"
                  />
                </div>
                <div className="box-6">
                  <Field
                    name="label_color"
                    label="Kolor"
                    handleChange={(color) => change("label_color", color)}
                    component={InputColorPickerField}
                  />
                </div>
              </div>
              <div className="row m-b-10">
                <div className="box-6">
                  <Field
                    name="identifier"
                    label="Identyfikator platformy"
                    component={InputField}
                    type="text"
                  />
                </div>
                <div className="box-6">
                  <Field
                    label="Typ platformy"
                    name="type"
                    component={SelectField}
                    options={platform_type_options}
                    handleChange={(value) => {
                      change("type", value);
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="box-6">
                  <Field
                    label="Kraj"
                    name="country_code"
                    component={SelectField}
                    options={available_countries_options}
                    handleChange={(value) => {
                      change("country_code", value);
                    }}
                  />
                </div>

                <div className="box-6">
                  <Field
                    label="Waluta"
                    name="currency_code"
                    component={SelectField}
                    options={available_currencies_options}
                    handleChange={(value) => {
                      change("currency_code", value);
                    }}
                  />
                </div>
              </div>
              <div className="row m-t-10">
                <div className="box-6">
                  <Field
                    label="Język"
                    name="language"
                    component={SelectField}
                    options={available_languages_options}
                    handleChange={(value) => {
                      change("language", value);
                    }}
                  />
                </div>
                <div className="box-6">
                  <Field
                    label="Maks. znaków w tytule oferty"
                    name="offer_title_max_length"
                    component={InputField}
                    type="number"
                    min="1"
                  />
                </div>
              </div>
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors["name"] = "Nazwa jest wymagana!";
  }

  if (!values.label_text) {
    errors["label_text"] = "Skrócona nazwa jest wymagana!";
  }

  if (!values.label_color) {
    errors["label_color"] = "Kolor jest wymagany!";
  }

  if (!values.identifier) {
    errors["identifier"] = "Identyfikator jest wymagany!";
  }

  if (!values.type) {
    errors["type"] = "Typ platformy jest wymagany!";
  }

  if (!values.country_code) {
    errors["country_code"] = "Kraj jest wymagany!";
  }

  if (!values.currency_code) {
    errors["currency_code"] = "Waluta jest wymagana!";
  }

  if (!values.language) {
    errors["language"] = "Język jest wymagany!";
  }

  if (!values.offer_title_max_length || Number(values.offer_title_max_length) < 1) {
    errors["offer_title_max_length"] = "Podaj maksymalną liczbę znaków większą od 0!";
  }

  return errors;
};

export default reduxForm({
  form: "create-platform",
  enableReinitialize: true,
  validate,
  initialValues: { offer_title_max_length: 100 },
})(PlatformsNew);
